/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface OrganisationInstitutionalIdDTO
 */
export interface OrganisationInstitutionalIdDTO  {
    /**
     * 
     * @type {number}
     * @memberof OrganisationInstitutionalIdDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganisationInstitutionalIdDTO
     */
    institution?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationInstitutionalIdDTO
     */
    value?: string;
}

/**
 * Check if a given object implements the OrganisationInstitutionalIdDTO interface.
 */
export function instanceOfOrganisationInstitutionalIdDTO(value: object): value is OrganisationInstitutionalIdDTO {
    return true;
}

export function OrganisationInstitutionalIdDTOFromJSON(json: any): OrganisationInstitutionalIdDTO {
    return OrganisationInstitutionalIdDTOFromJSONTyped(json, false);
}

export function OrganisationInstitutionalIdDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganisationInstitutionalIdDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'institution': json['institution'] == null ? undefined : json['institution'],
                  'value': json['value'] == null ? undefined : json['value'],
    };
}

export function OrganisationInstitutionalIdDTOToJSON(json: any): OrganisationInstitutionalIdDTO {
    return OrganisationInstitutionalIdDTOToJSONTyped(json, false);
}

export function OrganisationInstitutionalIdDTOToJSONTyped(value?: OrganisationInstitutionalIdDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'institution': value['institution'],
        'value': value['value'],
    };
}


